<template>
  <div class="welfare-login">
    <div class="girl"></div>
    <div class="icon-discount"></div>
    <div class="content">
      <div class="login-title"><AutoFontSize v-if="isShow">{{ $t('text_welfare_login_title') }}</AutoFontSize></div>
      <div class="subtitle">{{ $t('text_welfare_login_subtitle') }}</div>
      <div class="award-wrap">
        <div v-for="(value, key) in CONFIG" :key="key" class="award-item" :class="{ complete: value }">
          <div class="top">
            <div class="counpon">
              <div class="mask" v-if="value"></div>
              <div class="discount">10%</div>
              <div class="txt">{{ $t('coupon') }}</div>
            </div>
          </div>
          <div class="bottom">{{ $t(`text_${key}`) }}</div>
        </div>
      </div>
      <div class="btns">
        <div v-for="(value, key) in CONFIG" :key="key" class="btn-wrap">
          <div class="btn" v-if="value" @click="$bus.$emit('welfare-events', 'toStore')">{{ $t('text_use_now') }}</div>
        </div>
      </div>
    </div>
    <div class="rules">* {{ $t('text_welfare_rule_1') }}</div>
  </div>
</template>

<script>
import { storeLoginCoupon } from '@/server/api'
import { mapState } from 'vuex'
export default {
  name: 'Login',
  props: ['isShow'],
  data () {
    return {
      CONFIG: {
        login_2: false,
        login_7: false,
        login_30: false
      }
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  methods: {
    init () {
      storeLoginCoupon({ fpid: parseInt(this.userInfo.fpid || 0) }).then(res => {
        const coupons = res.coupons || []
        let hasCoupon = false
        for (let i = 0; i < coupons.length; i++) {
          const coupon = coupons[i]
          this.CONFIG[coupon.type] = true
          if (!coupon.is_used) hasCoupon = true
        }
        hasCoupon ? this.$emit('setDot', true) : this.$emit('setDot', false)
      })
    }
  }
}
</script>

<style lang='scss' scoped >
.welfare-login {
  width: calc(1398 * var(--unit-px));
  height: calc(792 * var(--unit-px));
  background: url(~@/assets/img/welfare/bg_login.jpg) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  margin-right: calc(71 * var(--unit-px));
  margin-top: calc(67 * var(--unit-px));
  .girl {
    width: calc(517 * var(--unit-px));
    height: calc(840 * var(--unit-px));
    position: absolute;
    bottom: 0;
    right: calc(59 * var(--unit-px));
    z-index: 1;
    background: url(~@/assets/img/welfare/bg_login_girl.png) no-repeat center center;
    background-size: 100% 100%;
  }
  .icon-discount {
    position: absolute;
    z-index: 2;
    width: calc(240 * var(--unit-px));
    height: calc(176 * var(--unit-px));
    top: calc(-40 * var(--unit-px));
    right: calc(-71 * var(--unit-px));
    background: url(~@/assets/img/welfare/bg_login_discount.png) no-repeat center center;
    background-size: 100% 100%;
  }
  .content {
    position: absolute;
    top: calc(52 * var(--unit-px));
    left: calc(71 * var(--unit-px));
    width: calc(770 * var(--unit-px));
    z-index: 3;
    .login-title {
      width: 150%;
      font-size: calc(60 * var(--unit-px));
      font-weight: bold;
      .auto-font-size {
        text-align: left;
      }
      ::v-deep(span) {
        color: #F0D7A2;
        line-height: 1.4;
        background: linear-gradient(180deg, #FCF5DC 0%, #E4C78A 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .subtitle {
      margin-top: calc(10 * var(--unit-px));
      font-size: calc(30 * var(--unit-px));
      height: calc(90 * var(--unit-px));
      font-weight: 500;
      color: #FFFFFF;
      line-height: 1.4;
      text-shadow: 0px 2px 2px rgba(0,0,0,0.74);
    }
    .award-wrap {
      margin-top: calc(50 * var(--unit-px));
      padding: calc(27 * var(--unit-px)) calc(31 * var(--unit-px)) calc(17 * var(--unit-px));
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      background-color: rgba(26, 15, 14, 0.70);
      border: 1px solid rgba(92, 90, 86, 1);
    }
    .top {
      width: calc(216 * var(--unit-px));
      height: calc(264 * var(--unit-px));
      background-color: rgba(98, 78, 76, 0.7);
      border: 1px solid rgba(120, 101, 97, 1);
      padding: calc(20 * var(--unit-px));
    }
    .counpon {
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/welfare/bg_login_days.png) no-repeat center center;
      background-size: 100% 100%;
      position: relative;
      padding-bottom: calc(48 * var(--unit-px));
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/welfare/bg_login_active.png) no-repeat center center;
      background-size: 100% 100%;
    }
    .discount {
      font-size: calc(70 * var(--unit-px));
      font-weight: bold;
      color: #FFFFFF;
      line-height: 1.2;
      text-shadow: 0px 2px 2px rgba(0,0,0,0.74);
    }
    .txt {
      font-size: calc(20 * var(--unit-px));
      font-weight: bold;
      color: #FFFFFF;
      line-height: 1.4;
      text-shadow: 0px 1px 2px rgba(0,0,0,0.74);
      margin-top: 2px;
    }
    .bottom {
      text-align: center;
      font-size: calc(30 * var(--unit-px));
      font-weight: bold;
      color: #FFFFFF;
      line-height: 1.4;
      text-shadow: 0px 2px 2px rgba(0,0,0,0.74);
      margin-top: calc(14 * var(--unit-px));
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: calc(20 * var(--unit-px)) calc(31 * var(--unit-px));
    }
    .btn-wrap {
      width: calc(216 * var(--unit-px));
      height: calc(60 * var(--unit-px));
    }
    .btn {
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/welfare/bg_btn_small.png) no-repeat center center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(24 * var(--unit-px));
      font-weight: 600;
      color: #473232;
      line-height: 1;
      cursor: pointer;
    }
  }
  .rules {
    position: absolute;
    z-index: 3;
    right: calc(38 * var(--unit-px));
    bottom: calc(18 * var(--unit-px));
    font-size: calc(24 * var(--unit-px));
    font-weight: 400;
    color: #FFFFFF;
    line-height: 1;
    text-shadow: 0px 2px 2px rgba(0,0,0,0.74);
  }
}
</style>
